export default "__VITE_PUBLIC_ASSET__61dd7dab__"